'use client'

import React from "react";
import {cn} from "@/lib/utils";

export default function ScrollingBanner({
  text,
  className = '',
}: {
  text: string | string[];
  className?: string;
}){
  const texts = (Array.isArray(text) ? text : [text]).filter(Boolean);

  if (!texts.length) return null;

  const itemCount = 30;
  const repeats = Math.ceil(itemCount / texts.length);

  const items = Array.from({ length: repeats }).flatMap((_, repeatIndex) =>
    texts.map((entry, entryIndex) => (
      <div
        key={`${repeatIndex}-${entryIndex}`}
        className="flex items-center flex-shrink-0 pr-[3rem] lg:pr-[5rem]"
      >
        <p className="text-[3rem] lg:text-[4rem] mb-0 leading-none font-funnel whitespace-nowrap pr-[3rem] lg:pr-[5rem]">
          {entry}
        </p>

        <svg className="w-[3rem] flex-shrink-0" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 8h16v4H0V8zm16-8h4v4h-4V0zm0 8h4v4h-4V8zm0 8h4v4h-4v-4zm4-12h4v4h-4V4zm0 8h4v4h-4v-4zm4-4h4v4h-4V8z"
            fill="currentColor"
          />
        </svg>
      </div>
    )),
  );

  return (
    <div className={cn(
      "relative overflow-clip py-[2.5rem] lg:py-[3rem] text-[#0A1A1D] bg-[#D9F9B9]",
      className
    )}>
      <div
        className="inline-flex items-center will-change-transform"
        style={{
          animation: `scrollRight ${30 * 1.5}s linear infinite`
        }}
      >
        {items}
      </div>
    </div>
  );
}